<template>
   <div class="resetPassword">
   <div class="row center-div">
     <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
     <div class="col-xs-4 col-sm-4 col-md-4 col-lg-5">
       <div class="panel panel-default background-color-grey">
         <div class="panel-body padding-bottom-2Perc">
           <div class="text-align-center">
              <div> <img :src= "imgSrc" class="img-responsive img-width  margin-Top-14Perc" alt="IPL-Logo"> </div>
             <div class=" font-size-28px">Reset Password</div>
             <div class="row Top-Bottom-Margin">
                <div class="col-md-12 col-lg-12 new-password-policy-intro-text">
                  {{constants.New_Password_Policy_Intro_Msg}}
                </div>
              </div>
             <div class="panel-body padding-top-0-px">
                <fieldset>
                   <div class="form-group">
                    <input type="password" class="form-control input-lg Top-Bottom-Margin" placeholder="Password" v-model="passwordValue" id="newPasswordId" @click="updateCurrentInputBox(1)">
                    <span class="p-viewer">
                      <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showNewPassword" aria-hidden="true" @click="revealPassword(1)"></i>
                      <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword(1)"></i>
                    </span>
                    <input type="password" class="form-control input-lg Top-Bottom-Margin" placeholder="Confirm Password" v-model="confirmPasswordValue" id="confirmPasswordId" @click="updateCurrentInputBox(2)">
                    <span class="p-viewer">
                      <i class="glyphicon glyphicon-eye-open color-orange cursor-pointer" v-if="!showConfirmNewPassword" aria-hidden="true" @click="revealPassword(2)"></i>
                      <i class="glyphicon glyphicon-eye-close color-orange cursor-pointer" v-else aria-hidden="true" @click="revealPassword(2)"></i>
                    </span>
                   </div>
                   <button class="btn btn-lg btn-primary btn-block btn-height" type="submit" @click="resetPassword">Reset</button>
                </fieldset>
             </div>
           </div>
         </div>
       </div>
     </div>
     <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"></div>
   </div>
   <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
     <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>
   <div class="row margin-Top-3Perc">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Copyright-Element class="footer"></Copyright-Element>
      </div>
    </div>
   </div> 
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import CopyrightElement from '@/components/CopyrightElement'
import { loginService } from '@/server-util/login-service'
import ipllettermark from '../assets/images/ipllettermark.svg'
export default {
  created: function () {
    this.isUserLoggedIn()
    this.startPasswordListener()
    // this.setPasswordKeyFromURL()
  },
  data: function () {
    return {
      constants: constants,
      passwordTxt: '',
      confirmPasswordTxt: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      passwordKey: '',
      isPasswordResetSuccessfully: false,
      imgSrc: ipllettermark,
      showNewPassword: false,
      showConfirmNewPassword: false,
      currSelectedInputBox: -1,
      passwordInterval: null
    }
  },
  components: {
    'alert-box': AlertBox,
    'Copyright-Element': CopyrightElement,
    'loader': Loader
  },
  computed: {
    passwordValue: {
      get: function () {
        return this.passwordTxt
      },
      set: function (newValue) {
        this.passwordTxt = newValue
      }
    },
    confirmPasswordValue: {
      get: function () {
        return this.confirmPasswordTxt
      },
      set: function (newValue) {
        this.confirmPasswordTxt = newValue
      }
    }
  },
  methods: {
    updateCurrentInputBox: function (clickedOption) {
      this.currSelectedInputBox = clickedOption
    },
    startPasswordListener: function () {
      this.passwordInterval = setInterval(() => {
        switch (this.currSelectedInputBox) {
          case 1:
            if (this.passwordValue.length === 0) {
              this.showNewPassword = false
              var x = document.getElementById('newPasswordId')
              if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
                x.type = this.showNewPassword ? 'text' : 'password'
              } else {
                this.clearPasswordInterval()
              }
            }
            break
          case 2:
            if (this.confirmPasswordValue.length === 0) {
              this.showConfirmNewPassword = false
              x = document.getElementById('confirmPasswordId')
              if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
                x.type = this.showConfirmNewPassword ? 'text' : 'password'
              } else {
                this.clearPasswordInterval()
              }
            }
            break
        }
      }, 100)
    },
    revealPassword: function (selectedIcon) {
      this.currSelectedInputBox = selectedIcon
      switch (this.currSelectedInputBox) {
        case 1:
          if (this.passwordValue.length > 0) {
            this.showNewPassword = !this.showNewPassword
            var x = document.getElementById('newPasswordId')
            if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
              x.type = this.showNewPassword ? 'text' : 'password'
            } else {
              this.clearPasswordInterval()
            }
          }
          break
        case 2:
          if (this.confirmPasswordValue.length > 0) {
            this.showConfirmNewPassword = !this.showConfirmNewPassword
            x = document.getElementById('confirmPasswordId')
            if (x !== undefined && x !== 'undefined' && x !== null && x !== 'null') {
              x.type = this.showConfirmNewPassword ? 'text' : 'password'
            } else {
              this.clearPasswordInterval()
            }
          }
          break
      }
    },
    clearPasswordInterval: function () {
      if (this.passwordInterval !== undefined && this.passwordInterval !== null) {
        clearInterval(this.passwordInterval)
      }
    },
    isUserLoggedIn: function () {
      console.log(this.$store.state.isUserProfileLoaded)
      if (this.$store.state.isUserProfileLoaded === true) {
        console.log('ACCESS DENIED: User trying to access Reset Password URL')
        this.$router.push('/')
      }
    },
    resetPassword: function () {
      if (this.validatedRequiredFieldsBeforeSubmit()) {
        var storeObj = this.$store
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          // this.showSpinner = true
          this.$store.state.isLoading = true
          loginService
            .resetPasswordUsingKey(
              this.passwordKey,
              this.passwordValue
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Your password reset successfully.'
                this.isPasswordResetSuccessfully = true
              } else {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'ACCESS TOKEN is NULL hence declined RESET PASSWORD.'
          )
        }
      }
    },
    validatedRequiredFieldsBeforeSubmit: function () {
      this.setPasswordKeyFromURL()
      if (this.passwordKey.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Something went wrong. Please try again.'
        return false
      } else if (this.passwordValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Password can\'t be empty.'
        return false
      } else if (this.confirmPasswordValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Confirm password can\'t be empty.'
        return false
      } else if (this.confirmPasswordValue !== this.passwordValue) {
        this.showAlertDialog = true
        this.errorMsg = 'New password and confirm password does not match.'
        return false
      }
      return true
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isPasswordResetSuccessfully) {
        // AK: Redirect user to Login Screen again
        this.isPasswordResetSuccessfully = false
        this.clearPasswordInterval()
        this.$router.push('/')
      }
    },
    setPasswordKeyFromURL: function () {
      this.passwordKey = this.$route.query.key
      // console.log('this.passwordKey >>> ' + this.passwordKey)
    }
  },
  name: 'resetPassword'
}
</script>

<style scoped>
.new-password-policy-intro-text {
  color: #ee6b1f;
  font-size: 12px;
}
.background-color-grey {
  background-color: #eeeeee;
}
.resetPassword {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-center {
    text-align: center;
}
.font-size-28px {
    font-size: 28px;
}
.input-lg {
    height: 46px;
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.3333333;
    border-radius: 6px;
}
.Top-Bottom-Margin {
    margin-top: 10px;
    margin-bottom: 20px;
}
.border-red{
  border: 1px solid red;
}
.center {
    margin: auto;
    width: 35%;
    border: 3px solid green;
    padding: 10px;
}
.center-div
{
  margin-top: 10%;
  /* margin-left:5%; */
}
/* Using Only for footer */
.footer{
  position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.img-width {
  text-align: center;
  width: 17%;
  margin: 0 auto;
}
.padding-bottom-2Perc{
  padding-bottom:2%;
}
.padding-top-0-px {
  padding-top: 0px;
}
.p-viewer {
  position: relative;
  margin: -50px 10px;
  float: right;
}
.color-orange {
  color: #EE6B1F;
}
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue